import React from 'react';
import { IconButton, Badge, Avatar } from '@mui/material';
import { styled } from '@mui/material/styles';

// Styled component for the online indicator
const OnlineBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: 'var(--green-310)',
    color: 'var(--green-310)',
    // boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
   
  },
}));

// Component usage
function UserAvatarIcon({ user, isOnline, onClick }) {
  // Get first letter of username or email
  const userInitial = user?.name?.[0]?.toUpperCase() || 
                     user?.email?.[0]?.toUpperCase() || 
                     'U';
  
  // Avatar color based on user
  const stringToColor = (string) => {
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    return color;
  };

  const avatarStyle = {
    bgcolor: "var(--brand-300)",
    width: 32,
    height: 32,
    fontSize: '0.875rem',
    fontWeight: 600,
    color : "var(--bran-950)"
  };

  return (
    <IconButton color="inherit" onClick={onClick} sx={{ p: 0 }}>
      {isOnline ? (
        <OnlineBadge
          overlap="circular"
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          variant="dot"
        >
          <Avatar sx={avatarStyle}>{userInitial}</Avatar>
        </OnlineBadge>
      ) : (
        <Avatar sx={avatarStyle}>{userInitial}</Avatar>
      )}
    </IconButton>
  );
}

export default UserAvatarIcon;